module.exports = __webpack_public_path__ + "static/CAN-73e3c456d39f4dc45ca4552cde3caa51.png";